// extracted by mini-css-extract-plugin
export default {"uaid":"gcdm-more-info_uaid__6Grat","content":"gcdm-more-info_content__oZ6Kg","table":"gcdm-more-info_table__sYIlY"};